import { render, staticRenderFns } from "./CCTableAcceptanceFilters.vue?vue&type=template&id=6a37b38a"
import script from "./CCTableAcceptanceFilters.vue?vue&type=script&lang=js"
export * from "./CCTableAcceptanceFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports